import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import {Store} from "@ngxs/store";
import {AccountState} from "../../states/account.state";
import {SwalUtil} from "../../util/swal-util";

@Injectable({
  providedIn: 'root'
})
export class AccountBelow2Guard  {

  constructor(
    private router: Router,private store:Store,
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const accountStatus = this.store.selectSnapshot(AccountState.getAccountStatus);
    if (accountStatus) {
      if (parseInt(accountStatus.level.id) < 2) {
        this.showMessage();
        return false;
      } else {
        return true;
      }
    } else {
      this.router.navigate(['/home'])
      return false;
    }
    return false;
  }

  protected showMessage() {
    SwalUtil.fireGenericMessage("Atención", "Antes de poder solicitar el Aumento de Límite, debes hacer la Verificación de Datos. ");
  }

}
